<template>
  <div style="height: 100%;">
    <el-container direction="vertical" class="layout-bottom">
      <Header/>
      <el-container class="layout-bottom" direction="horizontal">
        <el-aside width="200px" class="layout-bottom menu-bg">
          <div class="layout-bottom">
            <el-menu :router="true" background-color="#7CBEE3" active-text-color="white" text-color="white" :default-active="defaultActive">
              <el-menu-item index="/inventoryList">
                <i class="el-icon-menu" style="color: white;"></i>
                <span slot="title">清单清册</span>
              </el-menu-item>
              <el-menu-item index="/manage" v-if="hasManagementAuthority">
                <i class="el-icon-document" style="color: white;"></i>
                <span slot="title">组织及账号管理</span>
              </el-menu-item>
            </el-menu>
          </div>
        </el-aside>
        <el-main  class="layout-bottom">
          <router-view/>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import Header from './Header.vue'

export default {
  mounted () {
    if (this.$route.name === 'main') {
      this.$router.push({ name: 'login' })
    }
  },
  components: {
    Header
  },
  computed: {
    hasManagementAuthority () {
      return this.$oneitfarm.hasRole('usermanagement.organization')
    },
    defaultActive () {
      const routeName = this.$route.name
      switch (routeName) {
        case 'inventoryList': {
          return '/inventoryList'
        }
        case 'manage': {
          return '/manage'
        }
        default: {
          return ''
        }
      }
    }
  }
}
</script>
<style scoped>
.title-bottom {
  height: 20px;
  line-height: 20px;
  font-size: 12px;
}
.layout-bottom {
  height: 100% !important;
}
.layout-bottom > .el-menu {
  border: 0;
}
.menu-bg {
  background-color: #7CBEE3;
}
ul > .is-active {
  background-color: #6398B6 !important;
}
</style>
